import React from 'react'
import { useApp } from '../../context/AppContext'
import { Icon, useT } from '../../shared'
import { Card, Btn, Badge, Tabs } from '../../shared/components'
import { listAppraisalRequests } from '../../api/appraisals.api'
import { listDocs } from '../../api/cms.api'

function TaskRow({ icon, label, count, cta, onClick }) {
  if (!count) return null
  return (
    <div className="row between" style={{ alignItems: 'center', padding: '10px 0', borderBottom: '1px solid var(--border-subtle)' }}>
      <div className="row gap-2" style={{ alignItems: 'center' }}>
        <Icon name={icon} size={16} color="var(--amber)" />
        <span className="small">{label}</span>
        <Badge tone="warning">{count}</Badge>
      </div>
      <Btn variant="ghost" size="sm" onClick={onClick}>{cta}</Btn>
    </div>
  )
}

// Tab Announcement: hanya empty state — tidak ada fitur broadcast/pengumuman
// di backend Gladhy sama sekali, dan screenshot referensinya sendiri juga
// menampilkan empty state ini. Batas scope yang disengaja, bukan kekurangan.
function AnnouncementTab({ lang }) {
  return (
    <div className="col" style={{ alignItems: 'center', padding: '32px 0', gap: 6 }}>
      <Icon name="bell" size={22} color="var(--text-4)" />
      <div className="tiny muted">
        {lang === 'id' ? 'Belum ada pengumuman' : 'No announcement to display'}
      </div>
    </div>
  )
}

export function TasksTabPanel({ programs, programsWithoutParticipants, certPending }) {
  const { lang, navigate } = useApp()
  const t = useT()
  // null = belum dipilih admin: buka "Tasks" bila ada yang perlu ditindak,
  // karena tab Pengumuman hampir selalu kosong dan tidak berguna sebagai
  // layar pertama. Begitu admin mengklik tab, pilihannya yang berlaku.
  const [chosenTab, setTab] = React.useState(null)
  const [pendingAppraisals, setPendingAppraisals] = React.useState(0)
  const [pendingDocs, setPendingDocs] = React.useState(null) // null = belum di-fetch (lazy)

  React.useEffect(() => {
    listAppraisalRequests({ status: 'PENDING' }).then((r) => setPendingAppraisals(r.length)).catch(() => {})
  }, [])

  const taskCount = programsWithoutParticipants + pendingAppraisals + certPending + (pendingDocs || 0)
  const tab = chosenTab ?? (taskCount > 0 ? 'tasks' : 'announcement')

  React.useEffect(() => {
    if (tab !== 'tasks' || pendingDocs != null || !programs.length) return
    Promise.all(
      programs.map((p) => listDocs(p.id, { status: 'PENDING_REVIEW' }).catch(() => []))
    ).then((lists) => setPendingDocs(lists.reduce((sum, l) => sum + l.length, 0)))
  }, [tab, pendingDocs, programs])

  return (
    <Card title={lang === 'id' ? 'Aktivitas' : 'Activity'} noPad>
      <div style={{ padding: '18px 18px 0' }}>
        <Tabs
          value={tab}
          onChange={setTab}
          tabs={[
            { id: 'announcement', label: lang === 'id' ? 'Pengumuman' : 'Announcement' },
            { id: 'tasks', label: 'Tasks', count: taskCount || undefined },
          ]}
        />
      </div>
      <div style={{ padding: 18 }}>
        {tab === 'announcement' ? (
          <AnnouncementTab lang={lang} />
        ) : (
          <div className="col">
            <TaskRow
              icon="alert"
              label={lang === 'id' ? 'Program belum punya peserta' : 'Programs without participants'}
              count={programsWithoutParticipants}
              cta={lang === 'id' ? 'Daftarkan' : 'Enroll'}
              onClick={() => navigate('enrollment')}
            />
            <TaskRow
              icon="check"
              label={lang === 'id' ? 'Penilaian menunggu' : 'Pending appraisals'}
              count={pendingAppraisals}
              cta={lang === 'id' ? 'Lihat' : 'View'}
              onClick={() => navigate('penilaian')}
            />
            <TaskRow
              icon="cert"
              label={lang === 'id' ? 'Sertifikat pending' : 'Certificates pending'}
              count={certPending}
              cta={lang === 'id' ? 'Lihat' : 'View'}
              onClick={() => navigate('certificates')}
            />
            <TaskRow
              icon="doc"
              label={lang === 'id' ? 'Dokumen menunggu review' : 'Docs awaiting review'}
              count={pendingDocs}
              cta={lang === 'id' ? 'Lihat' : 'View'}
              onClick={() => navigate('doc-library')}
            />
            {taskCount === 0 && (
              <div className="tiny muted" style={{ padding: '12px 0' }}>
                {lang === 'id' ? 'Tidak ada yang perlu ditindak.' : 'Nothing needs attention.'}
              </div>
            )}
          </div>
        )}
      </div>
    </Card>
  )
}
